/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { greetingModelSchema } from "./greetingModelSchema.ts";
import { z } from "zod";

export const greetingModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => greetingModelSchema))
    })